import React, { Component } from 'react';

// import AccountCircle from '@material-ui/icons/AccountCircle';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import DeviceHub from '@material-ui/icons/DeviceHub';
import ExitToApp from '@material-ui/icons/ExitToApp';
import LocalShipping from '@material-ui/icons/LocalShipping';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  paperBottonNav: {
    position: 'fixed',
    bottom: '0px',
    width: '100%'
    // zIndex: '1300'
  },
  bottonNnav: {
    backgroundColor: '#eee'
  }
});

class Footer extends Component {
  render() {
    const { classes } = this.props;
    
    return (
      <div>
        <Paper className={classes.paperBottonNav}>
          <BottomNavigation className={classes.bottonNav} value={this.props.activeTab}>
            <BottomNavigationAction
              label={this.props.texts.deliv}
              showLabel={true}
              icon={<LocalShipping />}
              value='deliv'
              onClick={() => this.props.tabSelected("deliv")}
            />
            <BottomNavigationAction
              label={this.props.texts.sensors}
              showLabel={true}
              icon={<DeviceHub />}
              value='sensors'
              onClick={() => this.props.tabSelected("sensors")}
            />
            {/* <BottomNavigationAction
              label={this.props.texts.profile}
              showLabel={true}
              icon={<AccountCircle />}
              value='profile'
              onClick={() => this.select("profile")}
            /> */}
            <BottomNavigationAction
              label={this.props.texts.exit}
              showLabel={true}
              icon={<ExitToApp />}
              value='exit'
              onClick={() => this.props.logoutRequest()}
            />
          </BottomNavigation>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/index.js